import {getFromLocalStorage, setToLocalStorage} from "../../../utils/localStorageUtils";
import {LOCAL_STORAGE_IS_MENU_OPEN} from "../../../utils/constants";

const STORAGE_PERIOD_IN_HOURS = 365 * 24;
const MOBILE_SIDEBAR_BREAKPOINT = 891;

export const isMobileSidebarLayout = (screenWidth) => {
    return screenWidth < MOBILE_SIDEBAR_BREAKPOINT;
};

export const getSavedSidebarOpenState = () => {
    return getFromLocalStorage(LOCAL_STORAGE_IS_MENU_OPEN)?.value ?? true;
};

export const getInitialSidebarOpenState = (screenWidth) => {
    return isMobileSidebarLayout(screenWidth) ? true : getSavedSidebarOpenState();
};

export const persistSidebarOpenState = (isOpen) => {
    setToLocalStorage(LOCAL_STORAGE_IS_MENU_OPEN, {value: isOpen}, STORAGE_PERIOD_IN_HOURS);
};
